import {
  addQuery, removeQuery, decodeQuery, QueryVal,
} from 'Helpers/Query';
import history from 'State/history';

export const getModal = () => {
  const modalQuery = QueryVal('modal') || '';
  const [modalName, modalData] = modalQuery.split('_');

  return {
    modalName,
    modalData,
  };
};

export default function closeModal() {
  removeQuery('modal');
}

export function closeModalWithAdditionalKeys(...additionalKeyValues) {
  removeQuery('modal', additionalKeyValues);
}

export function openModal(modalKey, additionalKeyValues = []) {
  addQuery({ modal: modalKey }, ...additionalKeyValues);
}

export function toggleModal(modalKey) {
  const params = decodeQuery(history.location.search);
  if (params.modal && params.modal === modalKey) {
    removeQuery('modal', modalKey);
  } else {
    addQuery({ modal: modalKey });
  }
}
